<template lang="pug">
div
  div(:class="$style.errorPage")
    h1.text-4xl.leading-7xl
      | Dead end! Sorry about that.
      br
      | Please head back to our homepage
      br
      | or log in to find what you need.
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ErrorLayout",

  head() {
    return {
      title: "404"
    }
  }
})
</script>

<style lang="scss" module>
.errorPage {
  padding: 150px 0;
  text-align: center;
  background-size: cover;
  background-position-y: 50%;
  background-image: url("~assets/img/404_background.jpg");
  color: white;
  margin: -40px 0;
}
</style>
